import React, { useState, useEffect } from 'react';

import CustomDatePicker from '../../components/CustomDatePicker';
import CustomForm from '../../components/CustomForm';
import CustomInput from '../../components/CustomInput';
import CustomSelect from '../../components/CustomSelect';
import BackButton from '../../components/BackButton';
import FixedButton from '../../components/FixedButton';
import useFormInput from '../../hooks/useFormInput';

import useNumberInput from '../../hooks/useNumberInput';
import action from '../../store/action';
import { connect } from 'react-redux';

import { createLoanApi } from '../../api/loan';

import { createUserList } from '../../utils/utils';
import { getFullDate } from '../../utils/date';
import { getUserMethod } from '../../utils/api';
const today = new Date();

function LoanCreate({ global_action_loading, set_users, usersIsGet, add_loan, users }) {
  const [maturity_date, setTimeMaturity] = useState(today);
  const [open_date, setTimeOpen] = useState(today);
  const [count, setCount] = useState(0);
  const [broker_id, setBroker] = useState('');
  const [manager_id, setManager] = useState('');
  const [borrower_id, setBorrower] = useState('');
  const { brokerList, managerList, borrowerList } = createUserList(users);

  const name = useFormInput('', count);
  const establishment_fee = useNumberInput('', count);
  const withdrawal = useNumberInput('', count);
  const interest_rate = useNumberInput('', count);
  useEffect(() => {
    if (!usersIsGet) {
      getUserMethod(set_users, global_action_loading);
    }
  }, [usersIsGet, set_users, global_action_loading]);

  const submitLoan = () => {
    if (
      !withdrawal.value ||
      !manager_id ||
      !borrower_id ||
      !name.value ||
      !interest_rate.value ||
      !open_date ||
      !maturity_date ||
      !establishment_fee.value
    ) {
      alert('Please Enter Required Field');
      return;
    }

    global_action_loading();
    const data = {
      name: name.value,
      broker_id,
      manager_id,
      borrower_id,
      withdrawal: Number(withdrawal.value),
      establishment_fee: Number(establishment_fee.value),
      interest_rate: Number((interest_rate.value / 100).toFixed(5)),
      open_date: getFullDate(open_date),
      maturity_date: getFullDate(maturity_date),
      current_balance: (Number(withdrawal.value) + Number(establishment_fee.value)).toFixed(2)
    };

    createLoanApi(data)
      .then(res => {
        if (res.data.status === 200) {
          add_loan({ ...data, ...res.data.data });
          setCount(count + 1);
          setBroker('');
          alert('Added Successfully!');
        } else {
          alert(res.data.message);
        }
        global_action_loading(false);
      })
      .catch(err => {
        alert('Error');
        global_action_loading(false);
      });
  };

  return (
    <React.Fragment>
      <BackButton path='/loan' />
      <CustomForm>
        <CustomSelect
          value={borrower_id}
          onChange={event => {
            setBorrower(event.target.value);
          }}
          label='Borrower'
          required
          options={borrowerList}
        />
        <CustomInput {...name} label='Loan Name' placeholder='Loan  Name' required />
        <CustomInput {...withdrawal} label='Withdrawal' placeholder='Withdrawal' required />
        <CustomInput {...interest_rate} label='Interest(%)' placeholder='Interest(%)' required />
        <CustomInput {...establishment_fee} label='Establishment' placeholder='Establishment Fee' required />
        <CustomDatePicker
          label='Open Date'
          disabled
          value={open_date}
          onChange={date => {
            setTimeOpen(date);
          }}
        />
        <CustomDatePicker
          label='Maturity Date'
          value={maturity_date}
          onChange={date => {
            setTimeMaturity(date);
          }}
          disablePast
        />

        <CustomSelect
          value={manager_id}
          onChange={event => {
            setManager(event.target.value);
          }}
          label='Manager'
          options={managerList}
          required
        />
        <CustomSelect
          value={broker_id}
          onChange={event => {
            setBroker(event.target.value);
          }}
          label='Broker'
          options={brokerList}
        />
      </CustomForm>
      <FixedButton onClick={submitLoan}>Add Loan</FixedButton>
    </React.Fragment>
  );
}

export default connect(state => state.user, {
  ...action.globalLoading,
  ...action.user,
  ...action.loan
})(LoanCreate);
